/* VIVA63 — shared IntersectionObserver that toggles .is-inview on
   [data-viva-stage] and .viva-reveal elements. Late stage triggers add a
   separate class so scene backgrounds can start farther into the viewport. */
(function () {
  'use strict';
  if (window.__vivaInview) return;
  window.__vivaInview = true;

  var SELECTOR = '[data-viva-stage], .viva-reveal';
  var LATE_SELECTOR = '[data-viva-inview-late]';

  function activateLateTrigger(trigger) {
    var target = trigger.closest('[data-viva-stage]') || trigger.closest('.viva-stage__scene') || trigger;
    target.classList.add('is-background-inview');
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add('is-inview');
    });
    document.querySelectorAll(LATE_SELECTOR).forEach(function (el) {
      activateLateTrigger(el);
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          if (!entry.target.hasAttribute('data-viva-inview-toggle')) io.unobserve(entry.target);
        } else if (entry.target.hasAttribute('data-viva-inview-toggle')) {
          entry.target.classList.remove('is-inview');
        }
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
  );

  var lateIo = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        activateLateTrigger(entry.target);
        lateIo.unobserve(entry.target);
      });
    },
    { threshold: 0 }
  );

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.vivaObserved) return;
      el.dataset.vivaObserved = '1';
      io.observe(el);
    });
    document.querySelectorAll(LATE_SELECTOR).forEach(function (el) {
      if (el.dataset.vivaObservedLate) return;
      el.dataset.vivaObservedLate = '1';
      lateIo.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
